<template>
  <a-dropdown v-model="visible" placement="bottomRight" v-if="userName" :trigger="['click']">
    <span class="ant-pro-account-avatar" @click="onOpen" @mouseleave="onClose">
      <a-avatar size="small" :src="userImg" class="antd-pro-global-header-index-avatar user-img" />
    </span>
    <template v-slot:overlay>
      <div class="dropdown-box" @mouseenter="onOpen" @mouseleave="onClose">
        <div class="user">
          <a-avatar size="small" :src="userImg" class="antd-pro-global-header-index-avatar user-img" />
          <span>{{ userName }}</span>
        </div>
        <div class="platform-list">
          <div class="platform-item" v-for="item in enabledPlatform" :key="item.platformName">
            <img
              :src="
                require(`@/assets/platformIcon/${platformIcon[item.platformName]}${
                  (item.isEnable && item.isAvailable) || ['拼多多', '罗麦', '其他'].includes(item.platformName)
                    ? ''
                    : '-置灰'
                }.png`)
              "
              alt=""
            />
          </div>
        </div>
        <div class="footer">
          <a-button v-if="!firstLogin" size="small" class="ant-btn-custom ant-btn-default" @click="handleToCenter">
            <a-icon type="user" />
            个人中心
          </a-button>
          <a-button size="small" class="ant-btn-custom ant-btn-default" @click="handleLogout">
            <a-icon type="poweroff" /> 退出登录</a-button
          >
        </div>
      </div>

      <!-- <a-menu class="ant-pro-drop-down menu" :selected-keys="[]">
        <a-menu-item v-if="menu" key="center" @click="handleToCenter">
          <a-icon type="user" />
          个人中心
        </a-menu-item> -->
      <!-- <a-menu-item v-if="menu" key="settings" @click="handleToSettings">
          <a-icon type="setting" />
          {{ $t('menu.account.settings') }}
        </a-menu-item> -->
      <!-- <a-menu-divider v-if="menu" />
        <a-menu-item key="logout" @click="handleLogout">
          <a-icon type="logout" />
          {{ $t('menu.account.logout') }}
        </a-menu-item>
      </a-menu> -->
    </template>
  </a-dropdown>
  <span v-else>
    <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
  </span>
</template>

<script>
import { Modal } from 'ant-design-vue'
import storage, { set } from 'store'
import { mapState } from 'vuex'
import { platformList, platformIcon } from '@/config/contanst.js'

export default {
  name: 'AvatarDropdown',
  data() {
    return {
      platformIcon,
      userName: storage.get('userName') || '',
      userImg: require('@/assets/images/头像.png'),
      visible: false,
      timer: null,
    }
  },
  props: {
    currentUser: {
      type: Object,
      default: () => null,
    },
    menu: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      // 动态主路由
      info: (state) => {
        console.log('mapState>>', state.user.info)
      },
      enabledPlatform: (state) => state.user.enabledPlatform,
      role: (state) => state.user.role,
      type: (state) => state.user.type,
    }),
    firstLogin() {
      return this.$route.query.flag === 'first'
    },
    // allPlatformList() {
    //   const platforms = this.enabledPlatform.map((item) => item.platfrom) || []
    //   const allPlatformList = [...platformList]
    //   platforms.forEach((item) => {
    //     if (!allPlatformList.includes(item)) {
    //       allPlatformList.push(item)
    //     }
    //   })
    //   return allPlatformList
    // },
  },
  methods: {
    onOpen() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.visible = true
    },
    onClose() {
      if (!this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => (this.visible = false), 500)
    },
    handleMouseEnter() {
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout)
        this.closeTimeout = null
      }
    },
    handleMouseLeave() {
      this.closeTimeout = setTimeout(() => (this.visible = false), 300)
    },
    handleToCenter() {
      this.$router.push({ name: 'personalCenterIndex' })
    },
    // handleToSettings () {
    //   this.$router.push({ path: '/account/settings' })
    // },
    handleLogout(e) {
      Modal.confirm({
        title: this.$t('layouts.usermenu.dialog.title'),
        content: this.$t('layouts.usermenu.dialog.content'),
        okText: '确定',
        cancelText: '取消',
        centered: true,
        onOk: () => {
          // return new Promise((resolve, reject) => {
          //   setTimeout(Math.random() > 0.5 ? resolve : reject, 1500)
          // }).catch(() => console.log('Oops errors!'))
          return this.$store
            .dispatch('Logout')
            .then(() => {
              this.$router.push({ name: 'login' })
              this.$router.go(0)
            })
            .catch(() => console.log('Oops errors!'))
        },
        onCancel() {},
      })
    },
  },
}
</script>

<style lang="less" scoped>
.ant-pro-drop-down {
  :deep(.action) {
    margin-right: 8px;
  }
  :deep(.ant-dropdown-menu-item) {
    min-width: 160px;
  }
}
.ant-pro-account-avatar {
  display: flex !important;
  align-items: center;
  overflow: hidden;
}
.user-img {
  height: 32px;
  width: 32px;
}
.dropdown-box {
  width: 232px;
  // height: 152px;
  border-radius: 8px;
  padding: 16px 16px 8px;
  background: linear-gradient(180deg, #f0f4ff 0%, #fff 100%);
  box-shadow: 0 6px 30px 5px #0000000d, 0 16px 24px 2px #0000000a, 0 8px 10px -5px #00000014;
  .user {
    margin-bottom: 8px;
    .antd-pro-global-header-index-avatar {
      margin-right: 8px;
    }
    span {
      color: #000d4d;
      font-size: 14px;
      line-height: 22px;
      font-weight: bold;
    }
  }
  .platform-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 8px 11px;
  }
  .platform-item {
    width: 24px;
    height: 24px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .footer {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    margin-top: 8px;
    button {
      flex: 1;
      font-size: 12px;
      padding: 2px 12px;
    }
  }
}
</style>
